import httpClient from "Api/httpClient";

const END_POINT = "/companies";

const getCompanies = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getCompany = (company_id) => {
    if (!company_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + company_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printCompany = (company_id) => {
    if (!company_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?company_id=" + company_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createCompanies = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateCompanies = (payload, company_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + company_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteCompanies = (company_id) => {
    const DELETE_END_POINT = END_POINT + "/" + company_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

const assignCompanyUser = (payload, company_id) => {
    const UPDATE_END_POINT = END_POINT + "/" + company_id + "/users";
    return httpClient.post(UPDATE_END_POINT, payload);
};

const removeCompanyUser = (company_id, user_id) => {
    const DELETE_END_POINT = END_POINT + "/" + company_id + "/users/" + user_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

export { getCompanies, getCompany, printCompany, createCompanies, updateCompanies, deleteCompanies, assignCompanyUser, removeCompanyUser };
